import React, { useEffect, useRef, useState } from 'react'
import styles from './AuthorCollections.module.css'
import { Col, Row, Spin, Tabs, message, Typography, Divider, Card } from 'antd'
import CollectionsCard from '../CollectionsCard/CollectionsCard'
import { FeaturedCollectionCard, MoreFromAuthorCard, TopCollectionsCard } from '../SmallComponents/SmallComponents'
import { useDispatch, useSelector } from 'react-redux'
import MultipleSlider from '../Multiple Slider/MultipleSlider'
import EmptyData from '../EmptyData/EmptyData'
import { fetchUserBookmarks, fetchUserInteractions } from '../../Slices/PublicCollectionsDataSlice'
import AuthorAllCollections from '../AuthorAllCollections/AuthorAllCollections'
import AuthorHome from '../AuthorHome/AuthorHome'

const {Title} =Typography;





type Props = {
  authorId:any,
  featuredCollections:any,
  statistics:any,
  topCollections:any,
  pinnedCollection:any,
  authorDetailsLoading?:any,
}


  const onClick: any = (key:any) => {
    console.log("hey")
  };

const AuthorCollections = (props: Props) => {

  const {featuredCollections, topCollections, statistics, pinnedCollection, authorDetailsLoading, authorId } = props;

  const dispatch = useDispatch<any>();
  const [page, setPage] = useState(0);
  const {collections , pagination,  loading } = useSelector((state:any)=> state.authorCollections);
  const [newCollections, setNewCollections] = useState<any>([])
  const [totalPages, setTotalPages]= useState<any>();
  const spinRef = useRef(null);
  const [activeKey, setActiveKey] = useState<any>('home')


  useEffect(()=>{
    console.log(totalPages, 'TOTAL PAGES')
    console.log(page, "PAGE")
  }, [totalPages, page])


  const handleTabChange = (key:any)=>{
    setActiveKey(key);

    if(key === 'collections') {
        // setTotalPages(pagination?.total_pages)
    }
  }

// Intersection Observer Function Below

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };


    const callback = (entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setPage((prevPage:any) => prevPage + 1);
          console.log('Element is intersecting');
        }
      });
    };
    
  
    const observer = new IntersectionObserver(callback, observerOptions);
  
    if (spinRef.current) {
      observer.observe(spinRef.current);
    }
  
    return () => {
      observer.disconnect();
    };
  }, []);


  const items =  [
    {
      "label": "Home",
      "key": "home",
      "children" :  <AuthorHome pinnedCollection={pinnedCollection} authorDetailsLoading={authorDetailsLoading} featuredCollections={featuredCollections} topCollections={topCollections}/>
    },

    {
      "label": "Collections",
      "key": "collections",
      "children" : <AuthorAllCollections authorId={authorId} totalPages={totalPages} setTotalPages={setTotalPages} page={page} />
       
     
    },
    
    
  ]

  return (
    <>
    <Col span={24}>
    <Tabs defaultActiveKey={'home'} activeKey={activeKey} onChange={handleTabChange} items={items} onClick={onClick} />
    </Col>
    {pagination?.total_pages === 0 ? 
       <Row justify={"center"} style={(activeKey === 'home' || totalPages === page)  ?  {display: 'none'} : {rowGap: "20px"}}  gutter={20}>
       <EmptyData description={`No Collections`} buttonText={null} buttonOnClick={()=> console.log("")} />
     </Row>
      : 
    <Row justify={'center'} style={((activeKey === 'home' || totalPages <= page  ) && loading === false)  ?  {display: 'none'}  : {}} ref={spinRef} >
        <Spin/>
      </Row>
}
    </>
  )
}

export default AuthorCollections